import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./views/LandingPage/LandingPage";
import Home from "./views/Home/Home";
import "./App.css";
import { Record } from "./views/Record/Record";

const App: React.FunctionComponent = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<Record />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
